export default __webpack_public_path__ + "static/media/plevis.1d5626ea.png";